<template>
  <div>
    <!-- Primary Page Layout
    ==================================================-->

    <div class="section big-55-height over-hide z-bigger">
      <div class="parallax parallax-top" style="background-image: url('img/gallery-images/9.jpg')"></div>
      <div class="dark-over-pages"></div>

      <div class="hero-center-section pages">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-12 parallax-fade-top">
              <div class="hero-text">Check Availability</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="section padding-top-bottom-smaller background-dark over-hide z-too-big">
      <div class="section">
        <div class="container">
          <div class="row">
            <div class="col-md-12">
              <div class="row justify-content-center">
                <div class="col-md-6 col-xl-4 px-sm-0">
                  <div class="booking-sep-wrap">
                    <div class="input-daterange input-group" id="flight-datepicker-1">
                      <div class="form-item">
                        <span class="fontawesome-calendar"></span>
                        <input
                          class="input-sm"
                          type="text"
                          autocomplete="off"
                          id="checkin"
                          name="start"
                          placeholder="check-in"
                          data-date-format="yyyy-mm-dd"
                          v-model="userQuery.checkIn"
                        >
                        <span class="date-text date-depart"></span>
                      </div>
                      <div class="form-item">
                        <span class="fontawesome-calendar"></span>
                        <input
                          class="input-sm"
                          type="text"
                          autocomplete="off"
                          id="checkout"
                          name="end"
                          placeholder="check-out"
                          data-date-format="yyyy-mm-dd"
                          v-model="userQuery.checkOut"

                        >
                        <span class="date-text date-return"></span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-3 col-xl-2 px-sm-0">
                  <div class="quantity">
                    <input type="number" min="1" max="5" step="1" value="1" v-model="userQuery.guests">
                  </div>
                </div>
                <div class="col-md-3 col-xl-2 px-sm-0">
                  <a class="booking-button-big" href="search.html" @click="checkAvailabilty($event)">
                    check
                    <br>availability
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="loader" v-if="loader">
        <div class="loader__figure"></div>
    </div>
    
    <div class="mt-4">
      <div class="section padding-top-bottom z-bigger">
      <div class="section z-bigger">
        <div class="container">
          <div>
            <p class="text-center">{{ queryMessage }}</p>
          </div>
          <div class="row">
            <div class="col-lg-12">
              <div class="row bg-light" :class="{'mb-4': i !== rooms.length}" v-for="(room, i) in rooms" :key="room.roomTypeCode">
                <div class="col-lg-6 p-0">
                  <div class="room-name">{{ room.roomName }}</div>
                  <img :src="room.image" alt style="width: 100%; height: 100%">
                </div>

                <div class="col-lg-6  align-self-center">
                  <div class="row px-4">
                    <div class="col-lg-12">
                      <h4>{{ room.roomName }}</h4>
                      <br>
                      <div class="row p-4">
                        <table class="table">
                          <thead class="bg-dark text-white">
                            <tr>
                              <th>Rate</th>
                              <th>Price/Night</th>
                              <th>Availability</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="rate in room.rates" :key="rate.ratePlanCode">
                              <th>{{ rate.ratePlanName }}</th>
                              <th>${{ setNumberFormat(rate.rateCost) }}</th>
                              <th>{{ rate.availability }}</th>
                              <th>
                                <button class="btn btn-success btn-sm" @click="viewRate($event, rate, room)">View</button>

                                <!-- <button class="btn btn-success btn-sm" @click="selectRoom($event, room.roomTypeCode, rate.ratePlanCode)">Select</button> -->
                              </th>
                              
                            </tr>
                          </tbody>
                        </table>
                        <!-- <div class="col-md-4"> Name</div>
                        <div class="col-md-4">Rate Price</div>
                        <div class="col-md-4">Rate Price</div> -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
      <!-- <rooms-section></rooms-section> -->
      <div
      class="modal fade"
      id="rateModal"
      aria-labelledby="rateModal"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
      v-if="rate"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ rate.ratePlanName }}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="container">
              <div class="col-12">
                <h5>Rate Plans for {{ roomRateDetails.EffectiveDate }}</h5>
                <div class="row">
                  
                  <!-- <div class="col-md-12"><p>Availability</p></div> -->
                  <table class="table table-bordered col-md-12">
                    <thead>
                      <tr>
                        <th>Availability</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{{ rate.availability }}</td>
                      </tr>
                    </tbody>
                  </table>
                  <!-- <div class="col-md-6"><p></p></div> -->
                </div>
              </div>
              <div class="col-12">
                <div class="row">
                  <div class="col-md-12"><p>Rates</p></div>
                  <table class="table table-bordered col-md-12">
                    <thead>
                      <tr>
                        <th>Number Of Guests</th>
                        <th>Amount</th>
                        <th>Action</th>
                        <th>For All Dates</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(rateDet, index) in roomRateDetails.rateDetails.best_available_rates" :key="index">
                        <td>{{ rateDet.NumberOfGuests }}</td>
                        <td>${{ (rateDet.Amount/(10 ** rateDet.DecimalPlaces)) }}</td>
                        <td><button class="btn btn-light btn-sm " type="button" style="color:#000" @click="selectRate($event, index, roomRateDetails.rateDetails, roomRateDetails.rateDetails.best_available_rates[index], roomRateDetails.EffectiveDate)">Select</button></td>
                        <td><button class="btn btn-success btn-sm" @click="selectRateForAll($event, index, roomRateDetails.rateDetails, roomRateDetails.rateDetails.best_available_rates[index])">Select For All Dates</button></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="col-12">
                <div class="row">
                  <div class="col-md-12"><p>Length of Stay</p></div>
                  <table class="table table-bordered col-md-12">
                    <thead>
                      <tr>
                        <th>Stay</th>
                        <th>Length</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-if="roomRateDetails.rateDetails.length_of_stay">
                        <td>{{ roomRateDetails.rateDetails.length_of_stay.max.name }}</td>
                        <td>{{ roomRateDetails.rateDetails.length_of_stay.max.time }}</td>
                      </tr>
                      <tr v-if="roomRateDetails.rateDetails.length_of_stay">
                        <td>{{ roomRateDetails.rateDetails.length_of_stay.min.name }}</td>
                        <td>{{ roomRateDetails.rateDetails.length_of_stay.min.time }}</td>
                      </tr>
                    </tbody>
                  </table>

                    
                </div>
              </div>
              <div class="col-12">
                <div class="row">
                  <div class="col-md-12"><p>Restrictions</p></div>
                  <table class="table table-bordered col-md-12">
                    <thead>
                      <tr>
                        <th v-for="(restriction, index) in roomRateDetails.rateDetails.restriction_status" :key="index">{{ restriction.Restriction }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <td v-for="(restriction, index) in roomRateDetails.rateDetails.restriction_status" :key="index">{{ restriction.Status }}</td>
                    </tbody>
                  </table>

                  
                </div>
              </div>
              <!-- <div class="col-md-6">
                <h6>Login to Your Account</h6>
               
              </div>
              <div class="col-md-6">
                <h6>Register</h6>
               
              </div> -->
            </div>
          </div>
          <div class="modal-footer">
            <!-- <button type="button" class="btn btn-info" @click="">Next</button> -->
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
            <!-- <button type="button" class="btn btn-primary">Save changes</button> -->
          </div>
        </div>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
import Constants from '@/common/Constants.js'
import roomsSection from "@/components/rooms-section.vue";

export default {
  name: "Rooms",
  components: {
    roomsSection
  },
  data(){
    return{
      userQuery: {
        checkIn : '',
        checkOut: '',
        guests: 1,
      },
      rateTotal:0,
      userSelectedRates : [],
      roomRateDetails : {
        rateDetails : {
              best_available_rates :{
                Amount : ""
              },
              restriction_status :{
                Restriction : "",
                Status :""
              },
              length_of_stay : {
                max : {
                  name:"",
                  time :""
                },
                min : {
                  name:"",
                  time :""
                }
              }
            }
      },
      rooms:{},
      room:{},
      rateCount: 0,
      rate:{
        roomRates: [
          {
            rateDetails : {
              best_available_rates :{
                Amount : ""
              },
              restriction_status :{
                Restriction : "",
                Status :""
              },
              length_of_stay : {
                max : {
                  name:"",
                  time :""
                },
                min : {
                  name:"",
                  time :""
                }
              }
            }
          }
        ]

        
      },
      bookingDetails : {
        checkInDate  : "",
        checkOutDate : "",
        total : "",
        roomId : "",
        rateId: "",
        firstName : "",
        lastName: '',
        email : "",
        phoneNumber: "",
        numberOfGuests : "",
        numberOfRooms : "",
        additionalMessage : "",
        transactionId : "",
        guaranteed : false,
        userSelectedRates : {},
        errorMessage: '',
        error: false,
      },
      loader:false,
      queryMessage :""
    }
  },
  mounted(){
    var checkin = $("#checkin");
    checkin.datepicker({
      autoclose: true,
      format: "yyyy-mm-dd",
      maxViewMode: 0,
      startDate: "now",
    }).on("changeDate", function (e) {
          var dt2 = $('#checkout');
          dt2.datepicker('setStartDate', e.date );
          dt2.datepicker('setDate', e.date);
      });

    var checkout = $("#checkout");
    checkout.datepicker({
      autoclose: true,
      format: "yyyy-mm-dd",
      maxViewMode: 0,
      startDate: "now"
    });

    

    if(localStorage.queryData && localStorage.rooms){
      this.userQuery = JSON.parse(localStorage.queryData);
      this.rooms = JSON.parse(localStorage.rooms);
      console.log(this.rooms);
    }
    this.userQuery = JSON.parse(localStorage.queryData);

    
  },
  methods: {
    checkAvailabilty : function(event){
      event.preventDefault()     
      this.userQuery.checkIn = $("#checkin").val();
      this.userQuery.checkOut = $("#checkout").val();

      if(this.validateQuery(this.userQuery)){
        this.loader = true;
        this.$http
          .post(Constants.API_SEARCH_URL, this.userQuery)
          .then(response => {
            this.loader = false;
            localStorage.queryData = JSON.stringify(this.userQuery);
            localStorage.rooms = JSON.stringify(response.data.result);
            this.rooms = response.data.result;
                  

            if(this.rooms.length < 1 ){
              this.queryMessage = "No more accommodation available.";
            }else{
              this.queryMessage = "";
            }
            console.log(response.data);
            console.log(this.queryMessage);
            // this.$router.push("search");
          })
          .catch(function(error) {
            if (error.response) {
              this.loader = false;
              var message = "Unable to complete request.";
              alert(message);
            }
          });
      }else{
        alert('Unable to complete request');
      }
    },

    validateQuery(query){
      if(
          query.checkIn != '' &&
          query.checkOut != '' &&
          query.guests != 0 &&
          isNaN(query.guests) != true
      ){
          return true;
      }

      return false;
    },

    selectRoom($event, roomTypeCode, ratePlanCode){
      this.room = this.rooms[roomTypeCode];
      this.rate = this.room.rates[ratePlanCode];

      localStorage.room = JSON.stringify(this.room);
      localStorage.rate = JSON.stringify(this.rate);
      localStorage.queryData = JSON.stringify(this.userQuery);
      localStorage.requestDetails = '';
      this.$router.push('book-details');

    },
    viewRate($event, rate, room){
      $("#rateModal").modal("toggle");
      this.rateCount = 0
      this.rate = rate;
      this.room = room;
      this.bookingDetails.rateId = rate.ratePlanId;
      this.bookingDetails.roomId = room.roomId;
      this.roomRateDetails = rate.roomRates[this.rateCount];
      // console.log(rate.roomRates[this.rateCount]);
      console.log(rate, room, this.roomRateDetails);

    },
    selectRate($event, rateIndex, selectedRateDetails, selectedRate, effectiveDate){

      this.rateTotal += parseInt(selectedRate.Amount);

      this.userSelectedRates.push({
        "index" : rateIndex,
        "date" : effectiveDate,
        "priceDetails" : selectedRate
      });
      // console.log(selectedRateDetails.best_available_rates[0].DecimalPlaces);

      this.rateCount += 1;
      // console.log(count);
      if(this.rate.roomRates[this.rateCount]){
        this.roomRateDetails = this.rate.roomRates[this.rateCount];        
      }else{
        this.bookingDetails.userSelectedRates = this.userSelectedRates;
        this.bookingDetails.total = this.rateTotal;
        this.bookingDetails.checkInDate = this.userQuery.checkIn;
        this.bookingDetails.checkOutDate = this.userQuery.checkOut;
        this.bookingDetails.numberOfGuests = this.userQuery.guests;
        this.bookingDetails.decimalPlaces = selectedRateDetails.best_available_rates[0].DecimalPlaces;
        $("#rateModal").modal("toggle");
        this.rateTotal = 0;
        this.rateCount = 0;
        localStorage.bookingDetails = JSON.stringify(this.bookingDetails);
        localStorage.room = JSON.stringify(this.room);
        localStorage.rate = JSON.stringify(this.rate);

        this.$router.push('book-details');
      }
      // console.log(this.rate.roomRates[count]);
    },
    selectRateForAll($event, rateIndex, selectedRateDetails, selectedRate){
      // console.log(selectedRateDetails);
      console.log(selectedRate);
      this.userSelectedRates = [];

      var startDate = moment(this.userQuery.checkIn, 'YYYY-MM-DD');
      var endDate = moment(this.userQuery.checkOut, 'YYYY-MM-DD');
      var days = endDate.diff(startDate, 'days');
      this.rateTotal = 0;
      // console.log(startDate._i);
      for(var i = 0; i < days; i ++){
        this.rateTotal += parseInt(selectedRate.Amount);
        let currentDate = moment(this.userQuery.checkIn, 'YYYY-MM-DD').add(i, 'days').format('YYYY-MM-DD');
        this.userSelectedRates.push({
          "index" : rateIndex,
          "date" : currentDate,
          "priceDetails" : selectedRate
        });
      }

      this.bookingDetails.userSelectedRates = this.userSelectedRates;
      this.bookingDetails.total = this.rateTotal;
      this.bookingDetails.checkInDate = this.userQuery.checkIn;
      this.bookingDetails.checkOutDate = this.userQuery.checkOut;
      this.bookingDetails.numberOfGuests = this.userQuery.guests;
      this.bookingDetails.decimalPlaces = selectedRateDetails.best_available_rates[0].DecimalPlaces;

      $("#rateModal").modal("toggle");
      // console.log(this.bookingDetails, this.userQuery.checkIn);
      localStorage.bookingDetails = JSON.stringify(this.bookingDetails);
      localStorage.room = JSON.stringify(this.room);
      localStorage.rate = JSON.stringify(this.rate);
      this.$router.push('book-details');

      // console.log();
    },
    setNumberFormat(numberToFormat){
      var formattedNumber = numeral(numberToFormat).format('0, 0.[00]');
      return formattedNumber;
    }
  }
  // components: {
  //   headerNav
  // }
};
</script>
